/* global axios */
import ApiClient from './ApiClient';

class AudioRecordingsAPI extends ApiClient {
  constructor() {
    super('audio_recordings', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  upload(blob) {
    const formData = new FormData();
    formData.append('file', blob, 'recording.ogg');
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  remove(name) {
    return axios.delete(`${this.url}/${name}`);
  }

  download(name) {
    return axios.get(`${this.url}/${name}`, { responseType: 'blob' });
  }
}

export default new AudioRecordingsAPI();
